<template>

  <div class="resume-page">
    <van-loading v-show="loading" class="loading">

    </van-loading>
    <div class="flex_column" v-if="info&&info.id" style="height: 100px" @click ="pushUserInfo">
      <div class="flex_row">
        <div class="bolder24">{{ this.info.name }}</div>
        <icon-svg class="arrow" name="arrow_right"/>
      </div>

      <div class="norma14"><div v-if="info.work_years">工作{{this.info.work_years}}&nbsp; <span class="sepatLine">|</span> &nbsp; </div> 本科</div>
    </div>
    <div class="flexBorder" v-else>
      <div class="bolder18">个人信息</div>
      <div @click="addFunction('info')"><icon-svg class="add" name="icon_add"/></div>
    </div>
    <div  v-if="info&&info.education_history_ourput_dtos.length">
      <div class="flex">
        <div class="bolder18">教育经历</div>
        <div @click="addFunction('edu')"><icon-svg class="add" name="icon_add"/></div>
      </div>
      <div class="edu">
        <div class="item" v-for="(item,index) in info.education_history_ourput_dtos" :key="item.id"  @click="pushEducation(item)">
          <div class="eduItem" style="margin-top: 20px">
            <div class="font16">{{item.school_name}}</div>
            <div class="font12">{{item.begin_date|formatshortDate_}}至{{item.end_date|formatshortDate_}}</div>
          </div>
          <div class="eduItem" style="margin-top: 10px;margin-bottom: 20px">
            <div class="font12">{{item.education.text}}&nbsp;&nbsp;<span class="sepatLine">|</span>&nbsp;&nbsp;{{item.specialities}}</div>
            <div><icon-svg class="arrow" name="arrow_right"/></div>
          </div>
          <div class="line" v-if="index!= info.education_history_ourput_dtos.length-1"></div>
        </div>
      </div>
    </div>


    <div class="flexBorder" v-else>
      <div class="bolder18">教育经历</div>
      <div @click="addFunction('edu')"><icon-svg class="add" name="icon_add"/></div>
    </div>

    <div  v-if="info&&info.work_history_output_dtos.length">
      <div class="flexWork">
        <div class="bolder18">工作经历</div>
        <div @click="addFunction('work')"><icon-svg class="add" name="icon_add"/></div>
      </div>
      <div class="edu">
        <div class="item" v-for="(item,index) in info.work_history_output_dtos" :key="item.id" @click="pushWork(item)">
          <div class="eduItem" style="margin-top: 20px">
            <div class="font16">{{item.company_name}}</div>
            <div class="font12">{{item.begin_date|formatshortDate_}}至{{item.end_date|formatshortDate_}}</div>
          </div>
          <div class="eduItem" style="margin-top: 10px;">
            <div class="font12">{{item.job_title}}</div>
            <div><icon-svg class="arrow" name="arrow_right"/></div>
          </div>
          <div class="eduItem" style="margin-bottom: 20px">
            <div class="introduction" >{{item.performance}}</div>
          </div>
          <div class="line" v-if="index!= info.work_history_output_dtos.length-1"></div>
        </div>
      </div>
    </div>

    <div class="flexBorder" v-else>
      <div class="bolder18">工作经历</div>
      <div @click="addFunction('work')"><icon-svg class="add" name="icon_add"/></div>
    </div>
    <div class="flexNoBoder" >
      <div class="bolder18">附件</div>
      <van-uploader :disabled="fileList.length>=8"  :after-read="afterRead" accept="image/*,.pdf,.doc.,.docx"  :max-count="8" max-size="20*1024*1024" >
        <div ><icon-svg class="add" name="icon_add"/></div>
      </van-uploader>

    </div>
    <div  :class="fileList.length>0?'file':'fileLine'">
      提示：文件（图片、Word、PDF)必须小于20M
    </div>
    <div class="fileDiv">
<!--      <div v-for="item in info.file_dtos" :key="item.id" class="imageDiv">-->
<!--        <img  class="fileImage" :src="item.url"  @click="showImage(item.url)" >-->
<!--      </div>-->
      <van-uploader v-model="fileList" upload-icon="plus"   :show-upload=false >
        <template #preview-cover=" file ">
          <div class="preview-cover van-ellipsis">{{file.name}}</div>
        </template>
      </van-uploader>
    </div>
    <div class="submit-content" v-if="(info&&info.file_dtos&&info.file_dtos.length) ||  fileList.length">
      <van-button class="submit-btn" block  type="info" native-type="submit" @click="onSubmit" ><span>保存</span></van-button>
    </div>
<!--    <div class="flex" v-for="(item) in list" :key="item.id">-->
<!--      <div class="bolder">{{ item.name }}</div>-->
<!--      <div @click="addFunction(item.id)"><icon-svg class="add" name="icon_add"/></div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {mapState} from "vuex";
import {Toast} from "vant";
import cookies from "@/libs/util.cookies";
import util from "../../libs/util";
export default {
  name: "index",
  data(){
    return  {
      user_id: cookies.get('uid'),
      info:'',
      fileList:[

      ],
      loading: true,
      list:[
        {
          id:'info',
          name:'个人信息',
        },
        {
          id:'edu',
          name:'教育经历',
        },
        {
          id:'work',
          name:'工作经历',
        },
        {
          id:'file',
          name:'附件',
        }
      ]
    }
  },
  created() {
    const shareParam = {
      title: "卫宁健康期待您的加入",
      desc: "正在热招",
      link:process.env.VUE_APP_BASEURL +'#/',
      imgUrl: process.env.VUE_APP_SHARE_IMG_URL
    }
    util.initWXSdk(shareParam)
  },
  mounted() {
    const param = {
      user_id: this.user_id
    }
    this.$api.RESUME_GET(param).then(res=>{
      this.loading = false
      if(res){
        if(res.education_history_ourput_dtos){
          res.education_history_ourput_dtos.map(item=>{
            const  education = this.educationTypeList.filter(it=>{
              return  it.key == item.education
            })[0]
            return  item.education = education
          })
        }
        if(res.file_dtos){
          res.file_dtos = res.file_dtos.map(item=>{
            item.url = process.env.VUE_APP_IMAGE_URL+'/file/image?id='+ item.id
            return item
          })

          this.fileList = res.file_dtos.map(item=>{

            const newItem = {
              name:item.file_name,
              id:item.id,
              isImage:true
            }
            if(item.type === 'application/pdf'){
              newItem.url = require('../../assets/images/jobs/icon_pdf@2x.png')

            }else if(item.type.indexOf('image')>-1){
              newItem.url = item.url
              newItem.isImage = true
            }else{
              newItem.url = require('../../assets/images/jobs/icon_word@2x.png'),
                  newItem.isImage = true
            }
            return newItem

          })
        }
        this.info = res
      }
    }).finally(()=>{
      this.loading = false
    })

  },
  computed: {
    ...mapState('dic', ['educationTypeList'])
  },
  methods:{
    // showImage(url){
    //   ImagePreview({
    //     images: [
    //      url
    //     ],
    //     closeable: true,
    //   });
    // },
    onSubmit(){
      if(this.info&&this.info.id){
        const imageArr = this.fileList.map(item=>{
          return item.id
        })
        const param = {
          user_id: this.user_id,
          enclosure:imageArr
        }
        this.$api.RESUME_ENCLOSURE_SAVE(param).then(()=>{
          Toast( '保存成功')
        })
      }else{
        Toast( '先完善个人信息后才能创建简历')
      }

    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('filename', file.file.name);
      formData.append('type', file.file.type);
      this.loading = true
      this.$api.RESUME_File_SAVE(formData).then(res=>{
        Toast('上传成功')

        if(file.file.type === 'application/pdf'){

          this.fileList.push({
            url: require('../../assets/images/jobs/icon_pdf@2x.png'),
            name:file.file.name,
            id:res.id,
            isImage: true
          })
        }else if(file.file.type.indexOf('image')>-1){
          this.fileList.push({
            url: process.env.VUE_APP_IMAGE_URL+'/file/image?id='+ res.id,
            name:file.file.name,
            id:res.id,
            isImage: true
          })
        }else{
          this.fileList.push({
            url: require('../../assets/images/jobs/icon_word@2x.png'),
            name:file.file.name,
            id:res.id,
            isImage: true
          })
        }
      }).finally(()=>{
        this.loading = false
      })
    },

    pushWork( item ){
      this.$router.push({
        name: 'ResumeWork',
        params:{
          workId:item.id
        }
      })
    },
    pushUserInfo(){
      const info = {
        name:this.info.name,
        startwork_date:this.info.startwork_date,
        mobile:this.info.mobile,
        email:this.info.email,
        sex:this.info.sex
      }
      this.$router.push({
        path: 'userInfo/'+JSON.stringify(info),

      })
    },
    pushEducation(item){
      this.$router.push({
        path: 'resume/education/'+JSON.stringify(item)
      })
    },
    addFunction(index){
      switch (index) {
          case 'info':{
            this.$router.push({
              name: 'UserInfo'
            })
            break
          }
        case 'edu':{
          if(this.info&&this.info.id){
            this.$router.push({
              name: 'ResumeEducation'
            })
          }else{
            Toast( '先完善个人信息后才能创建简历')
          }

          break
        }
        case 'work':{
          if(this.info&&this.info.id){
            this.$router.push({
              name: 'ResumeWork',
              query:{

              }
            })
          }else{
            Toast( '先完善个人信息后才能创建简历')
          }

          break
        }
        case 'file':{
          this.$router.push({
            name: '/resume/work'
          })
          break
        }
      }
    }
  }
}
</script>

<style scoped  lang="scss">
  .resume-page{
    height: calc(100vh - 50px);
    overflow-y: scroll;
    text-align: left;
}

  .add {
    width: 24px;
    height: 24px;
  }
  .arrow{
    width: 16px;
    height: 16px;
    margin-left: 10px;
  }

  .bolder18{
    font-weight: bold;
    font-size: 18px;
    color: #333333;
  }
  .file{
    font-size: 12px;
    margin-left: 20px;
    margin-top: 10px;
    color: #999999;
  }
  .fileLine{
    font-size: 12px;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
    color: #999999;
    padding-bottom: 20px;
    border-bottom: 1px solid #F1F4F6;
  }
  .fileDiv{
    margin-left: 20px;
    margin-top: 18px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 80px;
  }
  .font16{
    color: #333333;
    font-size: 16px;
  }
  .font12{
    color: #999999;
    font-size: 12px;
  }
  .sepatLine{
    color: #cccccc;
    font-size: 10px;
    width: 1px;

  }
  .fileImage{
    width: 72px;
    height: 72px;

  }
  .imageDiv{
    width: 72px;
    height: 72px;
    margin-right: 10px;

  }
  .bolder24{
    font-weight: bold;
    font-size: 24px;
    color: #333333;
  }
  .norma14{
    margin-top: 10px;
    font-size: 14px;
    color: #333333;
    display: flex;
    align-items: center;
    height: 20px;
    line-height: 20px;

  }
  .flex_column{
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 20px;
    margin-right: 20px;
    height: 100px;
    border-bottom: 1px solid #F1F4F6 ;
  }
  .introduction{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-top: 10px;
    color: #999999;
    font-size: 12px;
  }
  .line{
    background-color:#F1F4F6 ;
    height: 1px;
    margin-left: 20px;
    margin-right: 20px;
  }
  .flex_row{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .flex{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    margin-right: 20px;
    height: 60px;

  }
  .preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
  }
  .edu{
    background: #F8FAFB;
    border-radius: 10px;
    margin-left: 20px;
    margin-right: 20px;
    border-radius: 10px;
    border: 1px solid #F1F4F6;
  }
  .eduItem{
    display: flex;
    flex-direction: row;
    padding-left: 15px;
    padding-right: 15px;
    justify-content: space-between;
    align-items: center;
  }

  .flexBorder{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    margin-right: 20px;
    border-bottom: 1px solid #F1F4F6 ;
    height: 65px;
  }
  .flexWork{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    margin-right: 20px;
    height: 65px;
  }
  .flexNoBoder{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
  }
  .submit-content{
    position:fixed;
    bottom: 0;
    left:0;
    width:100%;
    padding-bottom: 10px;
    background:  linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  }

  .submit-btn{
    display:block;
    width:calc(100vw - 40px);
    height:44px;
    margin:0 auto;
    background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
    border-radius: 22px;
    font-size:16px;
    font-weight: bold;
    color:#fff;
  }

  ::v-deep .submit-btn.van-button--disabled{
    opacity:1;
  }
  ::v-deep .van-loading {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }
  ::v-deep .submit-btn.van-button--disabled span{
    opacity:0.5;
  }
  .height60{
    height: 60px;
  }
  .height65{
    height: 65px;
  }
</style>
